export default "__VITE_ASSET__CM9sXifR__"